module.exports = __webpack_public_path__ + "img/bidFailActive.f782c615.png";